import { createContext, ReactNode, useContext, useState } from "react";

interface IUserDetails {
  phoneNumber: string;
  name: string;
  email: string;
  billingTo: string;
  billingAddress: string;
  siteAddress: string;
}

interface AuthContextType {
  userDetails?: IUserDetails;
  handleQuoteNo: (quoteNo?: string) => void;
  handleInvoiceNo: (quoteNo?: string) => void;
  quoteNo?: string;
  invoiceNo?: string;
  login: (userDetails: IUserDetails) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);

type Props = {
  children: ReactNode;
};

export const AuthProvider = ({ children }: Props) => {
  const [userDetails, setUserDetails] = useState<IUserDetails | undefined>();
  const [quoteNo, setQuoteNo] = useState<string | undefined>();
  const [invoiceNo, setInvoiceNo] = useState<string | undefined>();

  const login = (userDetails: IUserDetails) => {
    setUserDetails(userDetails);
  };

  const handleQuoteNo = (quoteNo?: string) => {
    setQuoteNo(quoteNo);
  };

  const handleInvoiceNo = (invoiceNo?: string) => {
    setInvoiceNo(invoiceNo);
  };

  const logout = () => {
    setUserDetails(undefined);
  };

  return (
    <AuthContext.Provider
      value={{
        userDetails,
        login,
        logout,
        handleQuoteNo,
        quoteNo,
        handleInvoiceNo,
        invoiceNo,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
